export class TcListSortModel {
  key: string;
  order: string;
}
